// extracted by mini-css-extract-plugin
export default {"container":"search_container__POUrZ","content":"search_content__8AArY"};